import { createApp } from "vue";

import RevocationForm from "../views/RevocationForm.ce.vue";
import { createPinia } from "pinia";

customElements.define('revocation-component', class extends HTMLElement {
    connectedCallback() {
        const container = document.createElement('div');
        container.id = 'app';
        this.appendChild(container);

        const regionId = this.getAttribute('data-region-id');

        const app = createApp(RevocationForm, { regionId });
        app.use(createPinia());
        app.mount(container);
    }
});
